import { AssertIsArrayException } from './assert-is-array.exception';

export function assertIsArray<T>(value: unknown): asserts value is T[] {
  if (!Array.isArray(value)) {
    throw new AssertIsArrayException(`Not a array: ${value}`);
  }
}
